/**
 * @generated SignedSource<<1e9e53ced87179db0f2136e2e8f30eef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserPage_activityLine$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly entity: {
        readonly cover_url: string;
        readonly id: string;
        readonly name: string;
        readonly original_name: string | null;
      };
    };
  } | null> | null;
  readonly " $fragmentType": "UserPage_activityLine";
};
export type UserPage_activityLine$key = {
  readonly " $data"?: UserPage_activityLine$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserPage_activityLine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserPage_activityLine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Activity",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Movie",
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "original_name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cover_url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ActivityConnection",
  "abstractKey": null
};

(node as any).hash = "ba5a66895f4f34a8fcba6eef7dbe77d3";

export default node;
